<template>
  <section class="story04">
    <div class="container">
      <h2 class="story04--tit">Meet Our Brands</h2>
      <div class="story04--txt">
          <p>척박한 자연에서 자라는 강인한 식물의 에너지와 생명력을 피부에 전달합니다.
          <p class="mb-2">BOTA (에너지 &amp; 생명력)</p>
          <p>위대한 자연에 대한 깊은 관찰은 원료 연구를 통해  효과적인 화장품을 개발하는 데 중요한 역할을 합니다.</p>
          <p class="mb-2">LAB (연구 &amp; 개발) </p>
      </div>
      <div class="row pb-6">
        <div class="col-sm-6 color-b">
          <h3 class="story04--tit2 mb-2">BI</h3>
          <!-- <img
            :src="image.imageLink"
            class="forth--bi pointer"
            alt="botalab"
            @click="downloadFile"
          /> -->
        <div class="story04--bi pointer" @click="downloadFile"></div>
        </div>
        <div class="col-sm-6 color-b">
          <h3 class="story04--tit2 mb-2">Color</h3>
          <div class="story04--colorbar"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import downloadApi from '@/apis/download';

export default {
  name: 'Section4',
  data() {
    return {
      image: { 
        id: 'Botalab_01', 
        imageLink: require('@/assets/images/brandstory/botalab02.png'), 
        downloadLink: `${process.env.VUE_APP_STATIC_URL}/HP-Rimankorea/CI/botalab.png` 
      },
    };
  },
  methods: {
    downloadFile() {
      downloadApi.downloadFile(this.image.downloadLink, this.image.downloadLink.substr(this.image.downloadLink.lastIndexOf('/') + 1));
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
